<template>
  <el-drawer v-model="visible" size="30%">
    <template #title>
      <span class="import-title">项目经历详情</span>
    </template>
    <el-form label-width="140px">
      <el-alert title="项目信息" type="info" :closable="false"></el-alert>
      <el-form-item label="项目标签：">{{proUser.label}}</el-form-item>
      <el-form-item label="项目状态："><el-input readonly v-model="proUser.statusName"></el-input></el-form-item>
      <el-form-item label="项目开始时间："><el-input readonly v-model="proUser.startUpDate"></el-input></el-form-item>
      <el-form-item label="项目预计结束时间："><el-input readonly v-model="proUser.planCompleteDate"></el-input></el-form-item>
      <el-form-item label="项目入群时间："><el-input readonly v-model="proUser.entryTimeString"></el-input></el-form-item>
      <el-form-item label="工种："><el-input readonly v-model="proUser.typeOfWorkName"></el-input></el-form-item>
      <el-form-item label="合同：">
        <img v-if="proUser.contractPath" :src="PdfIcon" class="pdf-img" @click="downloadContract" />
      </el-form-item>
      <el-form-item label="角色：">
        <el-button color="#81d3f8" size="small" style="color: white" v-if="isMamanger(proUser)">管理员</el-button>
        <el-button color="#81d3f8" size="small" style="color: white" v-if="proUser.directorId === userId">负责人</el-button>
      </el-form-item>
      <el-form-item label="在场状态："><el-input readonly v-model="proUser.workersStatus"></el-input></el-form-item>

      <el-alert title="其他信息" type="info" :closable="false"></el-alert>
      <el-timeline style="margin-top: 15px;">
        <el-timeline-item v-for="(record, index) in workStatusRecords" :key="index" :timestamp="record.opTimeString"
          :color="record.opTypeName == '离场' ? '#E6A23C' : '#67C23A'">
          {{ record.opTypeName }}
        </el-timeline-item>
      </el-timeline>
    </el-form>
    <template #footer>
      <div style="flex: auto">
        <el-button @click="visible = false">关闭</el-button>
      </div>
    </template>
  </el-drawer>
</template>
<script>
import { getProUserWorkStatusRecordList } from "@/api/sys/user";
import { defineComponent } from "vue";
import PdfIcon from '@/assets/icon/pdficon.svg';
import { downloadFile } from "@/utils/fileUtil";
import { getFileUrl } from "@/utils/common";
export default defineComponent({
  emits: ["update:modelValue"],
  data() {
    return {
      PdfIcon,
      workStatusRecords: []
    };
  },
  props: {
    modelValue: Boolean,
    proUser: Object,
    userId: String
  },
  computed: {
    visible: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    }
  },
  watch: {
    visible(val) {
      val && this.getWorkRecord();
    }
  },
  methods: {
    getWorkRecord() {
      getProUserWorkStatusRecordList(this.proUser.id).then(({data}) => {
        this.workStatusRecords = data.data;
      })
    },
    isMamanger(proUser) {
      if (proUser.isGroup === 1) {
        return proUser.isGroupAdministration === 1;
      }
      if (proUser.isTeam === 1) {
        return proUser.isTeamAdministration === 1;
      }
      return proUser.isProjectAdministration === 1;
    },
    downloadContract() {
      downloadFile(getFileUrl(this.proUser.contractPath), this.proUser.name + '合同');
    }
  }
});
</script>
<style lang="scss" scoped>
.import-title {
  font-weight: bold;
  color: #2483c6;
  font-size: 1.5em;
}
.pdf-img {
  width: 45px;
}
</style>